export default "__VITE_ASSET__lTPZrenA__"